export default __webpack_public_path__ + "static/media/defaultcover.c913ee70.svg";